var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"component-menu-image",attrs:{"src":_vm.specificData.image.url,"alt":_vm.specificData.image.filename}})
}
var staticRenderFns = []

export { render, staticRenderFns }